import React from 'react';
import { ProductCard } from './ProductCard';
import { products } from '../../data/products';
import { MapPin } from 'lucide-react';
export function ProductGrid() {
  return <section className="py-16 bg-white" data-id="element-614">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-615">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-616">
          {products.map(product => <ProductCard key={product.id} product={product} data-id="element-617" />)}
        </div>

        {/* Free Pickup Notice */}
        <div className="bg-slate-50 rounded-xl border border-slate-200 p-8 text-center" data-id="element-618">
          <div className="flex items-center justify-center mb-3" data-id="element-619">
            <MapPin className="h-5 w-5 text-[#dc2626] mr-2" data-id="element-620" />
            <h3 className="text-lg font-bold text-[#1a2332]" data-id="element-621">
              Free Pickup Available
            </h3>
          </div>
          <p className="text-slate-600" data-id="element-622">
            Order online and pick up your gear at any of our 6 locations during
            your next class.
          </p>
        </div>
      </div>
    </section>;
}